import { Injectable } from "@angular/core";

@Injectable()
export class RouteUtils {
  static getUrlParamKeys(queryParamMap: any) {
    const urlParamsKey = {};
    queryParamMap.forEach((key) => {
      urlParamsKey[`${key.toLowerCase()}URLKey`] = key;
    });
    return urlParamsKey;
  }
}
